import { useSyncExternalStore } from "react";

export const useHasHydrated = () => {
  return useSyncExternalStore(
    () => () => {}, // subscribe - no-op function
    () => true, // getSnapshot - always true on client
    () => false, // getServerSnapshot - always false on server
  );
};
